import { apiRequestToken } from '../Utilidades/apiRequest';
import { SolicitudComunicadosProps } from '../interfaces/solicitudComunicadosInterfaces';

export const getSolicitudes = async () => {
    return apiRequestToken({
        endpoint: 'solicitudes',
        method: 'GET',
    })
};
export const getSolicitud = async (id: String) => {
    return apiRequestToken({
        endpoint: `solicitudes/${id}`,
        method: 'GET',
    })
};
export const getSolicitudesNecesidades = async () => {
    return apiRequestToken({
        endpoint: 'solicitudesnecesidades',
        token: false,
        method: 'GET',
    })
};
export const getSolicitudesMensajes = async () => {
    return apiRequestToken({
        endpoint: 'solicitudesmensajes',
        token: false,
        method: 'GET',
    })
};
export const getSolicitudesEstatus = async () => {
    return apiRequestToken({
        endpoint: 'solicitudesestatus',
        method: 'GET',
    })
};
export const postEstatusSolicitudes = async (solicitud: SolicitudComunicadosProps) => {
    return apiRequestToken({
        endpoint: 'solicitudes/',
        body: solicitud,
        method: 'POST',
    })
};
export const postSolicitudes = async (solicitudComunicado: SolicitudComunicadosProps) => {
    return apiRequestToken({
        endpoint: 'solicitudes/',
        body: solicitudComunicado,
        token: false,
        method: 'POST',
    })
};